/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { saveAuthExpiration, redirectAfterLogin } from '../../../../../actions/auth'

import SsoReceiveToken from './SsoReceiveToken'

import type { RouteComponentProps } from 'react-router'

interface QueryStringParameters {}

interface StateProps {}

type DispatchProps = {
  saveAuthExpiration: (sessionExpirationTime: string) => void
  redirect: (redirectTo: string) => void
}

type ConsumerProps = RouteComponentProps<QueryStringParameters>

const mapStateToProps = (): StateProps => ({})

const mapDispatchToProps: DispatchProps = {
  saveAuthExpiration,
  redirect: redirectAfterLogin,
}

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(SsoReceiveToken)
